import { render } from "./App.vue?vue&type=template&id=a2d1ea44"
const script = {}

import "./App.vue?vue&type=style&index=0&id=a2d1ea44&lang=scss"

import exportComponent from "/codebuild/output/src3621675308/src/competition/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__